import { useState } from 'react'
import { FcGoogle } from "react-icons/fc";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { toast } from "react-toastify";
import axios from "axios";
import facebook_logo from "../../assets/admin/facebook_logo.svg";
import { useParams } from 'react-router-dom';

const CustomerRegister = (props) => {
    const { closeModal, restaurantId, setShowModalLogin, setShowModalReg } = props;

    const apiUrl = import.meta.env.VITE_METERI_API_BASE_URL;
    const [data, setData] = useState({
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        password: "",
        password_confirmation: "",
    });

    const [errors, setErrors] = useState({
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        password: '',
        password_confirmation: '',
    });

    // const [errors, setErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [logo, setLogo] = useState(null)
    const [selecteLogo, setSelecteLogo] = useState(null)
    const [logoError, setLogoError] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [showConfPassword, setShowConfPassword] = useState(false);
    const { rest_name } = useParams();

    const handleOnChange = (e) => {
        const { name, value } = e.target;

        if ((name === "password" && (value.length > 20 || /\s/.test(value))) ||
            (name === "password_confirmation" && (value.length > 20 || /\s/.test(value))) ||
            (name === "email" && /\s/.test(value))) {
            return;
        }
        setData((prev) => ({ ...prev, [name]: value }));
        setErrors((prev) => ({ ...prev, [name]: "" }));
    };

    // const validateForm = () => {
    //     const errors = {};

    //     if (!data.firstName.trim()) {
    //         errors.firstName = "First name is required.";
    //     }

    //     if (!data.lastName.trim()) {
    //         errors.lastName = "Last name is required.";
    //     }

    //     if (!data.email.trim()) {
    //         errors.email = "Email is required.";
    //     } else if (!/\S+@\S+\.\S+/.test(data.email)) {
    //         errors.email = "Email is invalid.";
    //     }

    //     if (!data.phone.trim()) {
    //         errors.phone = "Phone number is required.";
    //     } else if (!/^\d{10}$/.test(data.phone)) {
    //         errors.phone = "Phone number must be 10 digits.";
    //     }

    //     if (!data.password) {
    //         errors.password = "Password is required.";
    //     } else if (data.password.length < 6) {
    //         errors.password = "Password must be at least 6 characters.";
    //     }

    //     if (!data.password_confirmation) {
    //         errors.password_confirmation = "Confirm password is required.";
    //     } else if (data.password !== data.password_confirmation) {
    //         errors.password_confirmation = "Passwords do not match.";
    //     }

    //     return errors;
    // };

    // const handleSaveOld = async () => {
    //     // const errors = validateForm();

    //     // for (const key in errors) {
    //     //     if (errors[key]) {
    //     //         toast.error(errors[key], { theme: "colored", autoClose: 1000 });
    //     //         return;
    //     //     }
    //     // }

    //     // if(logoError) {
    //     //     console.log("No file selected. Please choose a file to upload")
    //     //     toast.error(logoError, { theme: "colored", autoClose: 1000 });
    //     //     return;
    //     // } else if (!selecteLogo) {
    //     //     toast.error("No file selected. Please choose a file to upload", { theme: "colored", autoClose: 1000 });
    //     //     return;
    //     // }

    //     if (logoError) {
    //         toast.error(logoError, { theme: "colored", autoClose: 1500 });
    //         return;
    //     }

    //     const formData = new FormData();
    //     formData.append('firstname', data.firstName);
    //     formData.append('lastname', data.lastName);
    //     formData.append('email', data.email);
    //     formData.append('phone', data.phone);
    //     formData.append('password', data.password);
    //     formData.append('password_confirmation', data.password_confirmation);

    //     if (selecteLogo) {
    //         formData.append('avatar', selecteLogo);
    //     }

    //     try {
    //         setIsLoading(true);

    //         const response = await axios.post(
    //             `${apiUrl}/api/v1/restaurants/${restaurantId}/register-end-user`,
    //             formData,
    //             {
    //                 headers: {
    //                     'Content-Type': 'multipart/form-data',
    //                 },
    //             }
    //         );

    //         const responseData = response.data;
    //         toast.success(responseData?.message, { theme: "colored", autoClose: 1500 });
    //         closeModal();
    //     } catch (error) {
    //         console.error('Error saving user data:', error);

    //         const errors = error?.response?.data?.errors || {};
    //         const errorFields = ['firstname', 'lastname', 'email', 'password'];

    //         errorFields.forEach((field) => {
    //             if (errors[field]?.[0]) {
    //                 toast.error(errors[field][0], { theme: "colored", autoClose: 1500 });
    //             }
    //         });

    //         if (!Object.keys(errors).length) {
    //             toast.error("An unexpected error occurred.", { theme: "colored", autoClose: 1500 });
    //         }
    //     } finally {
    //         setIsLoading(false);
    //     }
    // };

    const validateForm = () => {
        const newErrors = {};
        if (!data.firstName) newErrors.firstName = 'First Name is required';
        if (!data.lastName) newErrors.lastName = 'Last Name is required';
        if (!data.email) newErrors.email = 'Email is required';
        if (!data.password) newErrors.password = 'Password is required';
        if (data.password !== data.password_confirmation) {
            newErrors.password_confirmation = 'Passwords do not match';
        }
        setErrors(newErrors);
        return newErrors;
    };

    const handleSave = async () => {
        const validationErrors = validateForm();
        if (Object.keys(validationErrors).length > 0) {
            return;
        }

        if (logoError) {
            toast.error(logoError, { theme: "colored", autoClose: 1500 });
            return;
        }

        const formData = new FormData();
        formData.append('firstname', data.firstName);
        formData.append('lastname', data.lastName);
        formData.append('email', data.email);
        formData.append('phone', data.phone);
        formData.append('password', data.password);
        formData.append('password_confirmation', data.password_confirmation);

        if (selecteLogo) {
            formData.append('avatar', selecteLogo);
        }

        try {
            setIsLoading(true);
            const response = await axios.post(
                `${apiUrl}/api/v1/restaurants/${restaurantId}/register-end-user`,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                }
            );

            const responseData = response.data;
            toast.success(responseData?.message, { theme: "colored", autoClose: 1500 });
            closeModal();
        } catch (error) {
            console.error('Error saving user data:', error);

            const errors = error?.response?.data?.errors || {};
            const errorFields = ['firstname', 'lastname', 'email', 'password'];

            errorFields.forEach((field) => {
                if (errors[field]?.[0]) {
                    toast.error(errors[field][0], { theme: "colored", autoClose: 1500 });
                }
            });

            if (!Object.keys(errors).length) {
                toast.error("An unexpected error occurred.", { theme: "colored", autoClose: 1500 });
            }
        } finally {
            setIsLoading(false);
        }
    };


    const handleLogoChange = (e) => {
        const file = e.target.files?.[0];
        if (file) {
            // console.log(`Selected file size: ${file.size} bytes`);

            const maxSizeInBytes = 2 * 1024 * 1024; // 2MB
            if (file.size > maxSizeInBytes) {
                setLogoError('Max size: 2MB. Please upload a smaller file.');
                return;
            }

            const img = new Image();
            img.onload = () => {
                // console.log(`Image dimensions: ${img.width}x${img.height}`);

                // if (img.width !== 800 || img.height !== 600) {
                //     setLogoError('Recommended ratio: 800 x 600 px. Please upload a correctly sized image.');
                //     return;
                // }

                setLogoError('');
                const fileUrl = URL.createObjectURL(file);
                setLogo(fileUrl);
                setSelecteLogo(file);
            };

            img.onerror = () => {
                setLogoError('Invalid image file. Please select a valid image.');
            };

            img.src = URL.createObjectURL(file);
        } else {
            setLogoError('No file selected. Please choose a file to upload.');
        }
    };

    const redirectToLogin = () => {
        setShowModalLogin(true);
        setShowModalReg(false);
    }

    // const regWithGoogle = () => {
    //     window.close();
    //     console.log("login with Google");
    //     const apiUrl = import.meta.env.VITE_METERI_API_BASE_URL;
    //     const redirectUrl = `${apiUrl}/api/v1/auth/google/redirect?restaurant_id=${restaurantId}&frontend_redirect_url=http://192.168.1.161:5173/restaurant/${rest_name}`;
    //     console.log(redirectUrl, "redirectUrl of google")
    //     window.location.href = redirectUrl;
    // };

    const regWithGoogle = () => {
        if (rest_name) {
            console.log("Login with Google");
            // const currentUrl = window.location.href;
            // console.log("currentUrl", currentUrl)
            const { protocol, host } = window.location;
            const baseUrl = `${protocol}//${host}`;
            const apiUrl = import.meta.env.VITE_METERI_API_BASE_URL;
            const frontendRedirectUrl = `${baseUrl}/restaurant/${rest_name}`;
            // console.log(frontendRedirectUrl, "frontendRedirectUrl")
            const redirectUrl = `${apiUrl}/api/v1/auth/google/redirect?restaurant_id=${restaurantId}&frontend_redirect_url=${encodeURIComponent(frontendRedirectUrl)}`;
            window.location.href = redirectUrl;
        } else {
            console.log("restaurant slug is required");
        }
    };

    // const regWithFaceBook = () => {
    //     console.log("Login with Facebook");
    //     const apiUrl = import.meta.env.VITE_METERI_API_BASE_URL;
    //     const redirectUrl = `${apiUrl}/api/v1/auth/facebook/redirect?restaurant_id=${restaurantId}&frontend_redirect_url=http://192.168.1.161:5173/restaurant/${rest_name}`;
    //     console.log(redirectUrl, "Redirect URL for Facebook");
    //     window.location.href = redirectUrl;
    // };


    const regWithFaceBook = () => {
        if (rest_name) {
            console.log("Login with Facebook");
            // const currentUrl = window.location.href;
            // console.log("currentUrl", currentUrl)
            const { protocol, host } = window.location;
            const baseUrl = `${protocol}//${host}`;
            const apiUrl = import.meta.env.VITE_METERI_API_BASE_URL;
            const frontendRedirectUrl = `${baseUrl}/restaurant/${rest_name}`;
            // console.log(frontendRedirectUrl, "frontendRedirectUrl")
            const redirectUrl = `${apiUrl}/api/v1/auth/facebook/redirect?restaurant_id=${restaurantId}&frontend_redirect_url=${encodeURIComponent(frontendRedirectUrl)}`;
            window.location.href = redirectUrl;
        } else {
            console.log("restaurant slug is required");
        }
    };


    return (
        <div
            id="authentication-modal"
            role="dialog"
            aria-modal="true"
        // className="fixed top-0 left-0 z-50 flex justify-center items-center w-full h-full 
        // bg-gray-900 bg-opacity-50 overflow-x-hidden overflow-y-auto md:inset-0 h-[calc(100%-1rem)] max-h-full"
        >
            <div
                className=""
                tabIndex="-1"
                aria-hidden="false"
            >
                <div className="flex items-center justify-center">
                    <section className="sm:mt-5 mt-0  mx-5 my-5 max-w-[800px] w-full">
                        <div className="w-full h-auto  text-left text-red-700 space-y-5bg-[#f6efef] pt-6 md:p-6 p-4  font-sans">
                            <div className="flex justify-center">
                                <h3 className="text-3xl font-bold mb-3 md:mb-7 poppins-medium text-black">Registrazione</h3>
                            </div>
                            <div className="flex flex-col space-y-4 mb-4">
                                <div className="flex md:flex-row flex-col w-full gap-6">
                                    <div className="flex flex-col md:w-[50%] w-full space-y-3">
                                        <label className="text-lg font-semibold poppins-medium text-[#6B6B6B]">
                                            First Name<span className="text-red-500"> *</span>
                                        </label>

                                        <input
                                            type="text"
                                            name="firstName"
                                            className="poppins-regular px-4 py-3 text-xs text-[#8B8B8B] rounded-3xl bg-transparent border border-[#777777] focus:outline-none focus:border-[#d5d6d9] focus:bg-[#f6efef]"
                                            value={data.firstName || ""}
                                            onChange={handleOnChange}
                                        />
                                        {errors.firstName && (
                                            <div className="text-xs text-red-500 mt-1">{errors.firstName}</div>
                                        )}
                                    </div>
                                    <div className="flex flex-col md:w-[50%] w-full space-y-3">
                                        <label className="text-lg font-semibold poppins-medium text-[#6B6B6B]">
                                            Last Name<span className="text-red-500"> *</span>
                                        </label>
                                        <input
                                            type="text"
                                            name="lastName"
                                            className="poppins-regular px-4 py-3 text-xs text-[#8B8B8B] rounded-3xl bg-transparent border border-[#777777] focus:outline-none focus:border-[#d5d6d9] focus:bg-[#f6efef]"
                                            value={data.lastName || ""}
                                            onChange={handleOnChange}
                                        />
                                        {errors.lastName && (
                                            <div className="text-xs text-red-500 mt-1">{errors.lastName}</div>
                                        )}

                                    </div>
                                </div>
                                <div className="flex gap-3 md:flex-row flex-col">
                                    <div className="flex flex-col md:w-[50%] w-full space-y-3">
                                        <label className="text-lg font-semibold poppins-medium text-[#6B6B6B]">
                                            Email<span className="text-red-500"> *</span>
                                        </label>
                                        <input
                                            type="text"
                                            name="email"
                                            className="poppins-regular px-4 py-3 text-xs text-[#8B8B8B] rounded-3xl bg-transparent border border-[#777777] focus:outline-none focus:border-[#d5d6d9] focus:bg-[#f6efef]"
                                            value={data.email || ""}
                                            onChange={handleOnChange}
                                        />
                                        {errors.email && (
                                            <div className="text-xs text-red-500 mt-1">{errors.email}</div>
                                        )}
                                    </div>
                                    <div className="flex flex-col md:w-[50%] w-full space-y-3">
                                        <label className="text-lg font-semibold poppins-medium text-[#6B6B6B]">
                                            Phone
                                        </label>
                                        <input
                                            type="number"
                                            name="phone"
                                            className="poppins-regular px-4 py-3 text-xs text-[#8B8B8B] rounded-3xl bg-transparent border border-[#777777] focus:outline-none focus:border-[#d5d6d9] focus:bg-[#f6efef]"
                                            value={data.phone || ""}
                                            onChange={handleOnChange}
                                        />
                                    </div>
                                </div>
                                <div className="flex md:flex-row flex-col w-full gap-6">
                                    <div className="flex flex-col md:w-[50%] w-full space-y-3 relative">
                                        <label className="text-lg font-semibold poppins-medium text-[#6B6B6B]">
                                            Password<span className="text-red-500"> *</span>
                                        </label>
                                        <input
                                            type={showPassword ? "text" : "password"}
                                            name="password"
                                            className="poppins-regular px-4 py-3 text-xs text-[#8B8B8B] rounded-3xl bg-transparent border border-[#777777] focus:outline-none focus:border-[#d5d6d9] focus:bg-[#f6efef]"
                                            value={data.password || ""}
                                            onChange={handleOnChange}
                                        />
                                        {errors.password && (
                                            <div className="text-xs text-red-500 mt-1">{errors.password}</div>
                                        )}
                                        <button
                                            type="button"
                                            className="absolute inset-y-0 top-7 right-4 text-gray-400 hover:text-gray-600 h-[42px]"
                                            onClick={() => setShowPassword(!showPassword)}
                                        >
                                            {showPassword ? <FaEyeSlash /> : <FaEye />}
                                        </button>
                                    </div>
                                    <div className="flex flex-col md:w-[50%] w-full space-y-3 relative">
                                        <label className="text-lg font-semibold poppins-medium text-[#6B6B6B]">
                                            Confirm Password<span className="text-red-500"> *</span>
                                        </label>
                                        <input
                                            type={showConfPassword ? "text" : "password"}
                                            name="password_confirmation"
                                            className="poppins-regular px-4 py-3 text-xs text-[#8B8B8B] rounded-3xl bg-transparent border border-[#777777] focus:outline-none focus:border-[#d5d6d9] focus:bg-[#f6efef]"
                                            value={data.password_confirmation || ""}
                                            onChange={handleOnChange}
                                        />
                                        {errors.password_confirmation && (
                                            <div className="text-xs text-red-500 mt-1">{errors.password_confirmation}</div>
                                        )}
                                        <button
                                            type="button"
                                            className="absolute inset-y-0 top-7 right-4 text-gray-400 hover:text-gray-600 h-[42px]"
                                            onClick={() => setShowConfPassword(!showConfPassword)}
                                        >
                                            {showConfPassword ? <FaEyeSlash /> : <FaEye />}
                                        </button>
                                    </div>
                                </div>
                                <div className="flex flex-col md:w-[100%] w-full space-y-3">
                                    <label className="text-lg font-semibold poppins-medium text-[#6B6B6B]">
                                        Picture<span className="font-normal">Max File Size 800*600</span>
                                    </label>
                                    <div className="file-input poppins-regular px-4 py-3 text-[12px] text-[#8B8B8B] rounded-[50px] bg-transparent border border-[#777777] focus:outline-none focus:border-gray-400 focus:bg-[#e2dbdb]">
                                        <input type="file" onChange={handleLogoChange} accept="image/*" />
                                        <span className="button">Choose</span>
                                        <span className="label" data-js-label>No file selected</span>
                                    </div>
                                    {logoError && (
                                        <div className="text-xs text-red-500 mt-1">
                                            {logoError}
                                        </div>
                                    )}
                                    {logo && !logoError && (
                                        <div className="overflow-hidden mt-[10px] cursor-pointer h-full w-[100px] flex items-center justify-center">
                                            <img
                                                src={logo}
                                                alt="Preview"
                                                className="w-full object-cover rounded-lg shadow-md"
                                            />
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className=" text-sm justify-center w-full gap-2 max-w-full sm:max-w-[50%] mx-auto mt-7">
                                {isLoading ? (
                                    <button disabled type="button"
                                        className="w-full justify-center flex items-center space-x-2 p-4 border-[1.5px] border-[#d18d97] text-red-700 rounded-[30px] text-white text-base bg-[#8B2433] transition-colors group">
                                        <svg
                                            aria-hidden="true"
                                            className="w-4 h-4 text-gray-50 me-3 animate-spin dark:text-gray-600 fill-[#8B2433] invert"
                                            viewBox="0 0 100 101"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                                fill="currentColor"
                                            />
                                            <path
                                                d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                                fill="currentFill"
                                            />
                                        </svg>
                                        Loading...
                                    </button>
                                ) : (
                                    <button className="w-full justify-center flex items-center space-x-2 p-4 border-[1.5px] border-[#d18d97] text-red-700 rounded-[30px] text-white text-base bg-[#8B2433] transition-colors group"
                                        disabled={isLoading}
                                        onClick={handleSave}
                                    >
                                        <span className="poppins-regular uppercase block">Sign Up</span>
                                    </button>
                                )}
                                <p className="poppins-medium text-center text-[#a14c5b] text-base mt-3 mb-3 poppins-regular block">OR</p>
                            </div>
                            <div className="flex text-sm justify-center gap-4 flex-wrap md:flex-nowrap ">

                                <button
                                    className="min-w-[280px] flex items-center gap-2 text-black poppins-regular py-4 px-7 text-base  rounded-[30px] bg-transparent border border-[#777777] focus:outline-none "
                                    type="submit"
                                    onClick={regWithGoogle}
                                >
                                    <FcGoogle className="w-4 h-4" />
                                    Continue with Google
                                </button>

                                <button
                                    className="min-w-[280px] flex items-center gap-2 text-black poppins-regular py-4 px-7 text-base  rounded-[30px] bg-transparent border border-[#777777] focus:outline-none "
                                    type="submit"
                                    onClick={regWithFaceBook}
                                >
                                    <img
                                        src={facebook_logo}
                                        alt="Tick mark"
                                        className="w-4 h-4 filter transition-all duration-300 ease-in-out"
                                    />
                                    Continue with Facebook
                                </button>
                            </div>
                            <div className="text-center text-xs mt-7 poppins-medium">
                                <p className="text-[#132f40]  text-xl">
                                    Hai gia un account?{" "}
                                    <span
                                        onClick={() => redirectToLogin()}
                                        className="underline text-xl text-[#8B2433] cursor-pointer"
                                    >
                                        Accedi
                                    </span>
                                </p>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    );
}

export default CustomerRegister;



























